/**
 * 体型/几何体 → 运行时资产的映射与 id 生成（P0-3c）。
 * 单一来源：viewport 渲染、工具栏按钮、store 校验都从这里取，避免三处各写一份。
 */
import type { BodyType, GeometryType } from '../../model/director';

/**
 * 体型 → GLB 模型文件。
 * ⚠️ child 暂复用 standard（运行区还没有儿童素体）——已记技术债 D-25：
 * 4 体型齐备性待核，儿童体型待从 Mixamo 补录后替换此映射。
 */
export const BODY_TYPE_MODEL: Record<Exclude<BodyType, 'crowd' | 'geometry'>, string> = {
  standard: '/pose-models/character_00.glb',
  robust: '/pose-models/character_03.glb',
  broad: '/pose-models/character_04.glb',
  child: '/pose-models/character_00.glb',
};

export const BODY_TYPE_LABEL: Record<Exclude<BodyType, 'crowd' | 'geometry'>, string> = {
  standard: '防护服女',
  robust: '肌肉男',
  broad: '便装角色',
  child: '儿童(暂复用)',
};

/** 6 种几何体（P0-2 交付项，程序化生成，无模型文件） */
export const GEOMETRY_TYPES: readonly GeometryType[] = [
  'box', 'sphere', 'cylinder', 'torus', 'cone', 'pyramid',
];

export const GEOMETRY_LABEL: Record<GeometryType, string> = {
  box: '立方体',
  sphere: '球体',
  cylinder: '圆柱',
  torus: '环体',
  cone: '圆锥',
  pyramid: '棱锥',
};

export function isCharacterBody(t: BodyType | null): t is Exclude<BodyType, 'crowd' | 'geometry'> {
  return t === 'standard' || t === 'robust' || t === 'broad' || t === 'child';
}

/**
 * 生成不冲突的对象 id：obj_1、obj_2…跳过已占用。
 * 规则简单可预测——用户重开工程后 id 稳定，方便对账与调试。
 */
export function nextObjectId(existing: readonly string[], prefix = 'obj'): string {
  let i = 1;
  while (existing.includes(`${prefix}_${i}`)) {
    i += 1;
  }
  return `${prefix}_${i}`;
}
